import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const PATHOLOGY_PATH = "/pathology/v1";

// Pathology

export const getPathologyApi = async (params, options = {}) => await getRequest(`${PATHOLOGY_PATH}/list`, params, options);

export const getPathologyByIdApi = async (params, options = {}) => await getRequest(`${PATHOLOGY_PATH}/request/${params?.id}`);

export const updatePathologyApi = async (id, body) =>
  await putRequest(`${PATHOLOGY_PATH}/request/${id}`, body);

export const printPathologyApi = async (id) =>
  await getRequest(`${PATHOLOGY_PATH}/report/${id}/pdf`, {}, {
    responseType: "arraybuffer",
    headers: { Accept: "application/pdf" },
  });

export const deletePathologyByIdApi = async (id) =>
  await deleteRequest(`${PATHOLOGY_PATH}/request/${id}`);
